import { useMutation } from "@tanstack/react-query";
import { config } from "@/config";
import { useAuthHeaders } from "@/hooks/use-auth-headers";
import { apiFetch } from "@/lib/api-client";

export async function deleteFunctionalField(
  label: string,
  nodeId: string,
  keys: string[],
  token: string
): Promise<any> {
  const url = `${config.isometricApiUrl}/functional-graph/${label}/${nodeId}/field`;
  try {
    const response = await apiFetch(url, {
      method: "DELETE",
      body: JSON.stringify({ keys }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
    const errorData = await response.json();
    const error: any = new Error(errorData.message || 'Request failed');
    error.status = response.status;
    throw error;
  }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
}

export const useDeleteFunctionalField = (
  onSettled?: (res: any | undefined, error: Error | null) => void
) => {
  const { getAuthHeaders } = useAuthHeaders();

  return useMutation({
    mutationFn: (payload: {
      label: string;
      nodeId: string;
      keys: string[];
    }) => {
      const headers = getAuthHeaders();
      const token = headers.Authorization.replace("Bearer ", "");
      return deleteFunctionalField(
        payload.label,
        payload.nodeId,
        payload.keys,
        token
      );
    },
    onSettled,
  });
};